const api = {
  // 用户登录
  login: '/login',
  // 用户列表
  userList: '/userList',
  // 用户绑定员工
  userBindStaff: 'userBindStaff',
  // 用户订单统计
  userOrderCount: '/userOrderCount',
  // 用户详情
  userDetail: '/userDetail',
  // 分店列表
  shopList: '/shopList',
  // 新增分店
  addShop: '/addShop',
  // 编辑分店
  editShop: '/editShop',
  // 删除分店
  delShop: '/delShop',
  // 员工列表
  staffList: '/staffList',
  // 新增员工
  addStaff: '/addStaff',
  // 修改员工
  updateStaff: '/updateStaff',
  // 修改员工状态
  updateStaffStatus: '/updateStaffStatus',
  // 修改员工状态
  updatePermissions: '/updatePermissions',
  // x修改密码
  resetPassword: '/resetPassword',
  // 商品类别
  categorypList: '/categorypList',
  // 新增商品类别
  addCategory: '/addCategory',
  // 编辑商品类别
  editCategory: '/editCategory',
  // 删除商品类别
  delCategory: '/delCategory',
  // 广告列表
  advertList: '/advertList',
  // 新增广告
  addAdvert: '/addAdvert',
  // 编辑广告
  editAdvert: '/editAdvert',
  // 将广告下架
  shelvesAdvert: '/shelvesAdvert',
  // 删除广告
  delAdvert: '/delAdvert',
  // 商品列表
  goodsList: '/goodsList',
  // 商品列表
  getAllGoodList: '/getAllGoodList',
  // 新增商品
  addGoods: '/addGoods',
  // 编辑商品
  editGoods: '/editGoods',
  // 删除商品
  delGoods: '/delGoods',
  // 订单列表
  orderList: '/orderList',
  // 订单详情
  orderLogisticsList: '/orderLogisticsList',
  // 订单商品列表
  orderGoodsList: '/orderGoodsList',
  // 导出订单商品列表
  exportOrderGoodsList: '/exportOrderGoodsList',
  // 用户购物车列表
  shoppingCartList: '/shoppingCartList',
  // 用户地址清单
  userLogisticsAddressList: '/userLogisticsAddressList',
  // 填写订单物流信息
  fillOrderLogistics: '/fillOrderLogistics',
  // 修改用户地址
  updateUserAddress: '/updateUserAddress',
  // 文件上传
  fileUpload: '/fileUpload',
  // 供应商列表
  supplierList: '/supplierList',
  // 新增供应商
  addSupplier: '/addSupplier',
  // 修改供应商
  updateSupplierStatus: '/updateSupplierStatus',
  // 修改供应商
  updateSupplier: '/updateSupplier',
  // 删除供应商
  deleteSupplier: '/deleteSupplier',
  // 获取首页统计数据
  getReport: '/getReport',
  // 获取首页统计数据
  getReportData: '/getReportData',
  //  门店销售排行版
  shopSalesList: '/gateway/shopSalesList',
  //  业绩销售
  staffSalesList: '/gateway/staffSalesList',
  //  商品销售一览表
  goodsSalesList: '/gateway/goodsSalesList',
  //  商品销售一览表
  dailySalesList: '/gateway/dailySalesList',
  //  订单退款
  orderRefundList: '/orderRefundList',
  //  订单退款
  toExcel: '/toExcel',
  //  通知列表
  notifyList: '/notifyList',
  //  新增通知
  addNotify: '/addNotify',
  //  修改通知
  editNotify: '/editNotify',
  //  删除通知
  delNotify: '/delNotify',
  //  票券一览表
  ticketLtist: '/ticketLtist',
  //  票券明细表
  ticketInfoList: '/ticketInfoList',
  //  获取单个的订单明细信息
  getOrderDetail: '/getOrderDetail',
  //  票券赠送记录
  ticketRecord: '/ticketRecord',
  //  票券赠送记录
  staffAccountIoList: '/staffAccountIoList',
  //  票券赠送记录
  staffWithdrawalList: '/staffWithdrawalList',
  //  退款
  orderRefundByShop: '/gateway/orderRefundByShop',
  //  查看物流详情
  findOrderLogistics: '/gateway/findOrderLogistics',
  // 查看票券汇总表
  ticketSummaryList: '/gateway/ticketSummaryList',
  // 导出订单明细
  exportOrderDetail: '/exportOrderDetail',
  // 导出员工提现明细
  exportStaffWithdrawalList: '/exportStaffWithdrawalList',
  // 导出员工账户明细
  exportStaffAccountIoList: '/exportStaffAccountIoList',
  // 礼品卡分页列表
  giftCardList: '/giftCard/page',
  // 礼品卡导入模板下载
  exportGiftCardExcelTemp: '/giftCard/exportExcelTemp',
  // 礼品卡导入
  importGiftCardExcel: '/giftCard/importExcel'
}

export default api



// WEBPACK FOOTER //
// ./src/api/index.js